﻿var jquery = require('jquery');
require('jquery.mapster');
var Functions = require('./functions');
var WindowModal = require('../../Global/window-modal');
var HabEvents = require('../../Global/habitaclia-events');

(function () {

    var ModalZona = function (modalZonaDTO) {
        this.__modalZonaDTO = modalZonaDTO;
        __showModalMapaZona.call(this);
    };


    var __showModalMapaZona = function () {
        var self = this;
        var sData = '';

        jquery.post(this.__modalZonaDTO.urlGetMapaZona
            , 'action=getMapaZona&idioma='+ this.__modalZonaDTO.language
                + '&codProv=' + this.__modalZonaDTO.codProv
                + '&codPob=' + this.__modalZonaDTO.codPob
                + '&codZona=' + this.__modalZonaDTO.codZona)
            .done(function (data) {
                var oData = JSON.parse(data);
                if (oData.length > 0) {
                    var oElem = oData[1];

                    sData = Functions.NormalizeHTML(oElem.text);
                    sData += '<img id="idMapaZonaImg" useMap="#MapaZona" src="' + oElem.zona.img + '" />';
                    sData += '<map id="idMapaZonaCoords" name="MapaZona"><area data-group="zona" shape="poly" title="" coords="' + oElem.zona.coords + '" href="#"></map>';
                    __createModalMapaZona.call(self, Functions.NormalizeHTML(oElem.title), sData);
                }
            });

    };

    var __createModalMapaZona = function (sZona, sDataBody) {
        var oDialog = new WindowModal();
        oDialog.OnReady(__bindEventsModalMapaZona);
        oDialog.OnDestroy(__unbindEventsModalMapaZona);
        oDialog.CreateWindowModal({
            idSelectorString: 'js-dialog-mapa-zona',
            dataTitle: '<div class="titleModal">' + sZona + '</div><div class="closeModal"></div>',
            dataBody: '<div class="mapa-zona-ficha">' + sDataBody + '</div>',
            dataFooter: '<div class="callto-form"><input type="submit" id="idCerrar" class="button" name="cerrar" value="' + this.__modalZonaDTO.traducciones.cerrar + '" /></div>',
            modalWidth: '700px',
        });
    };

    var __bindEventsModalMapaZona = function () {

        jquery('.closeModal, #idCerrar').on('click', function (e) {
            e.preventDefault();
            jquery.publish(HabEvents.EventsEnum.CloseWindowModal);
        });

        var $mapaZona = jquery('#idMapaZonaImg');
        $mapaZona.mapster({ fillColor: 'ff6600', fillOpacity: 0.4, clickNavigate: false, singleSelect: true, isDeselectable: false, onMouseover: null, mapKey: 'data-group', areas: [{ key: 'zona', selected: true }] });
        $mapaZona.mapster('unbind', true);
    };


    var __unbindEventsModalMapaZona = function () {
        jquery('.closeModal').off('click');
        jquery('#idCerrar').off('click');
    };


    ModalZona.prototype = {
        constructor: ModalZona,
        ShowModalMapaZona: __showModalMapaZona
    };

    if (typeof module !== 'undefined' && module.exports) {
        /*jshint undef: false*/
        module.exports = ModalZona;
    }
    else {
        window.ModalZona = ModalZona;
    }

})();